import type { RouteLocationMatched, RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export interface BreadcrumbsProperties {
  path: string;
  to: string;
  text: string;
}

function getText(matched?: RouteLocationMatched, path?: string): string {
  if (matched?.meta?.title) {
    return matched.meta.title as string;
  }
  return path || '';
}

function getBreadcrumbs(
  route: RouteLocationNormalizedLoadedGeneric,
): BreadcrumbsProperties[] {
  const pathArray = route.path.split('/').filter(Boolean);

  if (pathArray.length === 0) {
    return [];
  }

  const breadcrumbs: BreadcrumbsProperties[] = [];

  for (let index = 0; index < pathArray.length; index += 1) {
    const path = pathArray[index];

    if (!path) {

      continue;
    }

    const previousBreadcrumb = breadcrumbs[index - 1];
    const to = previousBreadcrumb
      ? `${previousBreadcrumb.to}/${path}`
      : `/${path}`;

    const matched = route.matched[index];
    const text = getText(matched, path);

    breadcrumbs.push({ path, to, text });
  }

  return breadcrumbs;
}

export default getBreadcrumbs;
